import DM from 'DM';
import { isModuleSupported } from '../utils/browser-support';

const CTYPE = {
    home: 'index',
    products: 'category',
    trends: 'collectionlisting',
    article: 'article',
    other: 'other'
}

const WPJSLIB_SGAP_SOURCE = {
    MODULE: 'https://std.wpcdn.pl/wpjslib6/wpjslib-ecad.js',
    NOMODULE: 'https://std.wpcdn.pl/wpjslib/wpjslib-ecad.js'
};

const GEMIUS_CONFIG = {
    home: 'AfhLcudd2Hf06MPa9u4VAdWbTGRZYUQtKfu1ctxhCsL.a7',
    trends: '.RCVVuuGSTdvfbqSjo6p_8eCTH5kSuvB0TJJ89tDys..h7',
    others: 'olHldfepbcnOFbuzlt1h9KcT7MQsz4QLb7_1hTtDWlb.n7'
};

const ADS_CONFIG = {
    MOBILE: {
        prebidUrl: 'https://std.wpcdn.pl/adv/config/inline/mobile-domodi.pl.js',
    },
    DESKTOP: {
        prebidUrl: 'https://std.wpcdn.pl/adv/config/inline/desktop-domodi.pl.js',
    }
};

const ADS_REKID = {
    other: {
        desktop: 241889,
        mobile: 241893
    },
    collectionlisting: {
        desktop: 235968,
        mobile: 241894
    },
    category: {
        desktop: 241890,
        mobile: 241892
    },
    article: {
        desktop: 241888,
        mobile: 241891
    },
    index: {
        desktop: 235966,
        mobile: 236634
    }
};

const WP_SN = {
    PAGE: {
        MOBILE: 'domodi_mobile',
        DESKTOP: 'domodi'
    },
    TRENDS: {
        MOBILE: 'domodi_trendy_mobile',
        DESKTOP: 'domodi_trendy'
    }
};

const SCREEN_SIZE_LARGE = 1280;

const getRekId = (type) => {
    switch (type) {
        case CTYPE.home:
            return ADS_REKID.index
        case CTYPE.trends:
            return ADS_REKID.collectionlisting
        case CTYPE.products:
            return ADS_REKID.category
        case CTYPE.article:
            return ADS_REKID.article
        default:
            return ADS_REKID.other
    }
}

export default class WPJSLib {
    constructor({ entry, hasAds = false }) {
        const config = this.isMobile() ? ADS_CONFIG.MOBILE : ADS_CONFIG.DESKTOP;
        const device = this.isMobile() ? 'MOBILE' : 'DESKTOP';
        const name = entry === 'trends' ? WP_SN['TRENDS'][device] : WP_SN['PAGE'][device];
        const ctype = DM.EntryWithAction === 'trends/details' ? 'article' : CTYPE[entry]
        const rekId = getRekId(ctype)

        this.setGlobals({
            rekId: this.isMobile() ? rekId.mobile : rekId.desktop,
            gemiusId: GEMIUS_CONFIG[entry] ? GEMIUS_CONFIG[entry] : GEMIUS_CONFIG.others,
            name,
            ctype: ctype || CTYPE.other,
            ctaColor: '#E11239',
            consentText: '<strong>Domodi.pl - jesteśmy częścią WP Holding SA.</strong> ',
            logo: '/assets/symbols/domodi-logo.svg'
        });

        if (!DM.Utils.killTracker('wpjslib')) {
            this.loadWPJSSGAP(config.prebidUrl);
        }

        this.getConsent().then((consent) => {
            const consentLabel = consent ? 'Tak' : 'Nie';
            DM.Utils.trackEvents('consent_wp', 'consent_result', consentLabel, null, true);
            if (consent) {
                window.WP.cookieXD.get('statid', (statid) => {
                    DM.Utils.setCookie('dm_statid', statid.value);
                });
            }
        });
    }

    isMobile() {
        return window.innerWidth < SCREEN_SIZE_LARGE;
    }

    loadWPJSSGAP(prebid) {
        this.loadScript(prebid, {
            id: 'wpjslib-prebid'
        },
            () => {
                if (isModuleSupported()) {
                    this.loadScript(WPJSLIB_SGAP_SOURCE.MODULE, {
                        type: 'module',
                        id: 'wpjslib6'
                    });
                } else {
                    this.loadScript(WPJSLIB_SGAP_SOURCE.NOMODULE, {
                        nomodule: true,
                        id: 'wpjslib'
                    });
                }
            }
        )
    }

    loadScript(url, options, callback = () => { }) {
        const script = document.getElementsByTagName('script')[0];
        const lib = document.createElement('script');
        script.parentNode.insertBefore(lib, script);
        lib.async = true;
        lib.crossOrigin = 'anonymous';
        Object.keys(options).forEach(key => lib[key] = options[key]);
        lib.addEventListener('load', () => callback.call(lib), false);
        lib.src = url;
    }

    getConsent() {
        return new Promise((resolve, reject) => {
            try {
                window.WP.push(() => {
                    this.mark('WPJSLib_ConsentInit');
                    window.WP.gdpr.runAfterConsent(() => {
                        const consent = window.WP.gdpr.check('mr') || false;
                        this.mark('WPJSLib_ConsentResult');
                        resolve(consent);
                    });
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    setGlobals({ rekId, gemiusId, name, ctype, ctaColor, consentText, logo }) {
        window.rekid = rekId;
        window.wp_sn = name;
        window.wp_pp_gemius_service = 'gapl';
        window.wp_pp_gemius_identifier = gemiusId;
        window.wp_cookie_info = false;
        window.WP = window.WP || [];
        window.wp_consent_color = ctaColor;
        window.wp_consent_text = consentText;
        window.wp_consent_logo = logo;
       window.wp_consent_logo = logo;

        if (ctype === 'article') {
            const { cid, ccategory, cdate } = DM.Boot.TrackingScripts;

            window.wp_dot_addparams = {
                cpagemax: 1,
                cpageno: 1,
                csystem: 'domodi',
                cid,
                ccategory,
                cdate,
                ctype
            };
        } else if (ctype) {
            window.wp_dot_addparams = {
                ctype
            };
        }
    }

    registerDOMSlots(attr = 'data-gaf-slot') {
        window.WP.push(() => {
            [].forEach.call(document.querySelectorAll(`[${attr}]`), (el) => {
                const slotId = el.getAttribute(attr);
                if (window.WP.gaf) {
                    window.WP.gaf.registerSlot(slotId, el);
                }
            });
        });
    }

    loadSlots() {
        window.WP.push(() => {
            if (window.WP.gaf) {
                const slots = window.WP.gaf.getAllSlots();
                if (Object.keys(slots).length > 0) {
                    window.WP.gaf.loadBunch(
                        window.rekid,
                        this.markSlots(slots),
                        true
                    );
                }
            }
        });
    }

    refreshSlots() {
        window.WP.push(() => {
            if (window.WP.gaf) {
                const slots = window.WP.gaf.getAllSlots();
                if (Object.keys(slots).length > 0) {
                    window.WP.gaf.loadSlots(
                        window.rekid,
                        Object.keys(slots),
                        this.markSlots(slots),
                        true
                    );
                }
            }
        });
    }

    refreashPageHit() {
        if (typeof (gemius_hit) === 'function') {
            gemius_hit(GEMIUS_CONFIG.OTHERS);
        }

        if (WP && WP.stat && typeof (WP.stat.dot) === 'function') {
            WP.stat.dot(window.wp_sn + '_dynamic', null, 'top');
        }
    }

    markSlots(slots) {
        return () => Object.keys(slots).forEach((slotId) => this.mark(`WPJSLib_RunSlot${slotId}`));
    }

    mark(label) {
        if (window.performance) {
            window.performance.mark(label);
        }
    }
}
